import { ACTIONTYPE } from '../AppStateProvider';
import { useCallback } from 'react';
import { AudioCodecs, VideoCodecs } from './codecsEnum';

export interface CodecReport {
  codec: string | undefined;
  result: string;
}

export default function useCodecsTest(dispatch: React.Dispatch<ACTIONTYPE>) {
  return useCallback(() => {
    return new Promise(() => {
      try {
        var audioCodecSupportedFinalResult = false;
        var audioCodecsReport: CodecReport[] = [];
        var audioCodecList;
        try {
          audioCodecList = RTCRtpSender.getCapabilities('audio')!.codecs;
        } catch (error) {
          audioCodecList = null;
        }
        for (let value in AudioCodecs) {
          var audioCodecSupported = false;
          const keyValue: AudioCodecs = AudioCodecs[value as keyof typeof AudioCodecs];
          if (audioCodecList !== null) {
            audioCodecSupported =
              audioCodecList.some((v) => v.mimeType === keyValue) || supportsAudioType(keyValue) === 'probably';
          } else {
            audioCodecSupported = supportsAudioType(keyValue) === 'probably';
          }
          addAudioCodecsReport(audioCodecSupported, value);
        }

        function supportsAudioType(type: AudioCodecs) {
          let audio;
          if (!audio) {
            audio = document.createElement('audio');
          }
          return audio.canPlayType(type);
        }

        function addAudioCodecsReport(audioCodecIsSupported: boolean, codec: string) {
          if (audioCodecIsSupported) {
            audioCodecsReport.push({ codec: codec, result: 'Supported' });
            audioCodecSupportedFinalResult = true;
          } else {
            audioCodecsReport.push({ codec: codec, result: 'Not Supported' });
          }
        }

        if (audioCodecSupportedFinalResult) {
          dispatch({ type: 'audio-codecs-test-successful' });
          dispatch({ type: 'audio-codecs-test-report', report: audioCodecsReport });
        } else {
          dispatch({ type: 'audio-codecs-test-failed' });
          dispatch({ type: 'audio-codecs-test-report', report: audioCodecsReport });
        }
      } catch (error) {
        dispatch({ type: 'audio-codecs-test-failed' });
        dispatch({
          type: 'audio-codecs-test-report',
          report: [{ codec: undefined, result: 'Audio codecs not Supported' }],
        });
      }

      try {
        function supportsVideoType(type: VideoCodecs) {
          let video;
          if (!video) {
            video = document.createElement('video');
          }
          return video.canPlayType(type);
        }

        var videoCodecSupported = false;
        var videoCodecsReport: CodecReport[] = [];

        for (let value in VideoCodecs) {
          const keyValue: VideoCodecs = VideoCodecs[value as keyof typeof VideoCodecs];
          if (supportsVideoType(keyValue) === 'probably') {
            videoCodecsReport.push({ codec: value, result: 'Supported' });
            videoCodecSupported = true;
          } else {
            videoCodecsReport.push({ codec: value, result: 'Not Supported' });
          }
        }

        if (videoCodecSupported) {
          dispatch({ type: 'video-codecs-test-successful' });
          dispatch({ type: 'video-codecs-test-report', report: videoCodecsReport });
        } else {
          dispatch({ type: 'video-codecs-test-failed' });
          dispatch({ type: 'video-codecs-test-report', report: videoCodecsReport });
        }
      } catch (error) {
        dispatch({ type: 'video-codecs-test-failed' });
        dispatch({
          type: 'video-codecs-test-report',
          report: [{ codec: undefined, result: 'Video codecs not Supported' }],
        });
      }
    });
  }, [dispatch]);
}
